(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-history-list.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-history-list.js');

'use strict';

const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableHead = _svs$ui$reactTable.TableHead,
  TableRow = _svs$ui$reactTable.TableRow,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableBody = _svs$ui$reactTable.TableBody;
const useTransactions = svs.arena.shared.hooks.useTransactions;
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  TransactionHistoryErrorRow = _svs$arena$pages$team.TransactionHistoryErrorRow,
  TransactionHistoryEmptyRow = _svs$arena$pages$team.TransactionHistoryEmptyRow,
  TransactionHistoryRow = _svs$arena$pages$team.TransactionHistoryRow;
const Button = svs.ui.ReactButton;
const TransactionHistoryList = _ref => {
  let selectedTeam = _ref.selectedTeam;
  const dispatch = ReactRedux.useDispatch();
  const _useTransactions = useTransactions(selectedTeam, 60),
    teamTransactions = _useTransactions.data,
    hasMoreTransactions = _useTransactions.hasMoreItems,
    error = _useTransactions.error,
    isLoading = _useTransactions.isLoading;
  const getMoreTransactions = () => {
    dispatch(svs.arena.store.transactions.actions.fetchTransactions({
      syndicateId: selectedTeam,
      count: 20,
      transactionTimeUuid: teamTransactions[teamTransactions.length - 1].transactionTimeUuid
    }));
  };
  return React.createElement(React.Fragment, null, React.createElement(Table, {
    className: "transaction-history-table",
    striped: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, React.createElement("div", {
    className: "f-bold padding-xs-v"
  }, "Datum")), React.createElement(TableHeader, null, React.createElement("div", {
    className: "f-bold padding-xs-v"
  }, "Transaktionstyp")), React.createElement(TableHeader, null, React.createElement("div", {
    className: "f-bold padding-xs-v f-right"
  }, "Belopp")))), React.createElement(TableBody, null, !isLoading && error && React.createElement(TransactionHistoryErrorRow, null), !isLoading && !error && teamTransactions && teamTransactions.length === 0 && React.createElement(TransactionHistoryEmptyRow, null), !error && teamTransactions && teamTransactions.length > 0 && teamTransactions.map(item => React.createElement(TransactionHistoryRow, {
    key: item.transactionTimeUuid,
    transRow: item
  })))), hasMoreTransactions && React.createElement("div", {
    className: "margin-v-1 align-center"
  }, React.createElement(Button, {
    block: true,
    onClick: getMoreTransactions,
    size: 300,
    transparent: true
  }, "H\xE4mta fler")));
};
svs.arena.pages.teams.components.TransactionHistoryList = TransactionHistoryList;

 })(window);